import axios from 'axios';
import { installRefreshInterceptor, installForbiddenToastInterceptor } from '@bill/ui';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';
const CORE_API_URL = import.meta.env.VITE_CORE_API_URL || 'http://localhost:44050/api';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Install the shared JWT auto-refresh interceptor (from @bill/ui).
// Handles: request bearer token, 401 auto-refresh, concurrent request queue,
// logout on refresh failure. Shared with BStaff.
installRefreshInterceptor({ client: apiClient, coreApiUrl: CORE_API_URL });

// 403 toast (US-MAC.6) : un seul toast deduplique pour tous les codes 403
// (NO_SUBSCRIPTION, NO_MODULE_ROLE, ...) afin d'eviter le spam quand plusieurs
// requetes echouent en parallele.
installForbiddenToastInterceptor({ client: apiClient });
